import { FlowAuthType } from "../enums/FlowAuthType";

export const useDummyFlowStreamsListV2 = false;

// Return unpaginated list without deleted streams.
export const flowStreamsListV2 = [
    {
        id: 1,
        provider: {
            name: "Storehub POS",
            short_name: "storehub",
            authentication: FlowAuthType.HTTP_BASIC,
        },
        ext_name: "StoreHub Hubble 1 (ListV2)",
    },
    {
        id: 2,
        provider: {
            name: "Lazada Ecom",
            short_name: "lazada",
            authentication: FlowAuthType.OAUTH2,
        },
        ext_name: "Lazada Shop 1 (ListV2)",
    },
    {
        id: 3,
        provider: {
            name: "Shopee Ecom",
            short_name: "shopee",
            authentication: FlowAuthType.OAUTH2,
        },
        ext_name: "Shopee Shop 1 (ListV2)",
    },
    {
        id: 4,
        provider: {
            name: "Shopify Ecom",
            short_name: "shopify",
            authentication: FlowAuthType.OAUTH2,
        },
        ext_name: "Shopify Shop 1 (ListV2)",
    },
];
